var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "loading-cell" },
    [
      _c("v-progress-circular", { attrs: { indeterminate: "" } }),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.params.loadingMessage))]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }